module.exports = __webpack_public_path__ + "img/35.3535fb40.jpg";